<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header d-none d-md-none d-lg-block" v-if="cenarios.length == 0">
          <h4 class="card-title" v-html="titulo"></h4>
          <p class="card-category">{{ subtitulo }}</p>
        </div>
        <div class="card-body">
          <div class="content">
            <form @submit.prevent>
              <div class="row">
                <div class="col-md-12" style="display: flex; justify-content: space-between; align-items: center;">

                  <span style="display: inline-block">Dados Básicos</span>

                  <div style="display: flex; align-items: center;">

                    <b-button-toolbar class="d-none d-md-none d-lg-block" style="float: right" v-if="cenarios.length > 0">
                      <b-button-group>
                        <b-button @click="modalOpen('personalizar')" title="Personalizar" size="sm" class="mb-2">
                          <b-spinner small variant="success" v-if="!getLoadAllData()"
                            title="Aguarde o carregamento dos dados"></b-spinner>
                          <font-awesome-icon :icon="['far', 'edit']" v-if="getLoadAllData()" /> Personalizar
                        </b-button>
                        <b-button @click="modalOpen('envio')" title="Enviar" size="sm" class="mb-2">
                          <b-spinner small variant="success" v-if="!getLoadAllData()"
                            title="Aguarde o carregamento dos dados"></b-spinner>
                          <font-awesome-icon :icon="['far', 'paper-plane']" v-if="getLoadAllData()" />
                          Salvar/Enviar
                        </b-button>
                        <b-button @click="modalOpen('impressao')" title="Imprimir" size="sm" class="mb-2">
                          <b-spinner small variant="success" v-if="!loadingSession"
                            title="Aguarde o carregamento dos dados"></b-spinner>
                          <b-icon icon="printer" aria-hidden="true" v-if="loadingSession"></b-icon>
                          Imprimir
                        </b-button>
                      </b-button-group>
                    </b-button-toolbar>

                    <i v-b-toggle.collapse-1 class="ti-arrow-down ml-4" style="float: right"></i>
                  </div>

                </div>
              </div>
              <b-collapse :visible="cenarios.length == 0" id="collapse-1" class="mt-2">
                <div class="row">
                  <div class="col-12 col-md-6 mt-2">
                    <v-select id="cidades" v-model="filtros.cidade" :filterable="false" :options="cidades"
                      :selected="filtros.cidade" @search="onSearchCidade" v-bind:class="{ error: !filtros.cidade }"
                      label="cidade" placeholder="Cidades">
                      <template slot="no-options">Cidade não localizada</template>
                      <template slot="option" slot-scope="option">
                        {{ option.cidade }} - {{ option.uf }}
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        {{ option.cidade }} - {{ option.uf }}
                      </template>
                    </v-select>
                  </div>
                  <div class="col-12 col-md-6 mt-2">
                    <v-select id="credenciados" v-model="filtros.credenciado" :filterable="false" :options="credenciados"
                      @search="onSearchCredenciado" label="nome" placeholder="Credenciados">
                      <template slot="no-options">Credenciado não localizado</template>
                      <template slot="option" slot-scope="option">
                        {{ option.nome }}
                        <span class="credenciado_detalhes">{{ option.cidade }} - {{ option.uf }}</span>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        {{ option.nome }}
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="row" style="width: 100vw;">
                  <div class="col-12 col-md-6 col-lg-2 mt-2" style="display: flex ; width: fit-content">
                    <toggle-button id="inlineCheckboxRegrasAceitacao" v-model="filtros.regras_aceitacao" :sync="true"
                      :labels="{ checked: 'Sim', unchecked: 'Não' }"
                      :color="{ checked: '#2ba649', unchecked: '#db3747' }" />
                    &nbsp;
                    <label for="inlineCheckboxRegrasAceitacao">
                      Regras de Aceitação <b-icon icon="exclamation-circle-fill" variant="secondary"
                        v-b-popover.hover="'Ao deixar a regra ATIVA (ligada) o sistema irá verificar automaticamente os planos disponíveis que atendam a quantidade de vidas que você inseriu. Mas se você trocar para a INATIVA (desligada) o sistema vai ignorar as regras e exibir todos os planos independente das regras de aceitação por vidas de titulares e dependentes que o plano exige.'"></b-icon>
                      : {{ textRegrasAceitacao }}
                    </label>
                  </div>
                  <div class="col-12 col-md-6 col-lg-2 mt-2">
                    <div class="custom-control custom-checkbox">
                      <input class="custom-control-input" type="checkbox" id="inlineCheckboxSomarTaxas"
                        data-type="somar_taxas" true-value="1" false-value="2"
                        :checked="filtros.somar_taxas == 1 ? true : false" @click="toggleTaxas" />
                      <label class="custom-control-label" for="inlineCheckboxSomarTaxas">
                        Somar taxas: {{ textSomarTaxas }}
                        <b-icon icon="exclamation-circle-fill" variant="secondary"
                          v-b-popover.hover="'Ao deixar a regra ATIVA (ligada) o sistema irá somar as taxas ao total dos planos. Mas se você trocar para INATIVA (desligada) o sistema vai exibir os valores sem considerar as taxas de contratação. Em ambas situações o IOF será acrescido ao valor final.'"></b-icon>
                      </label>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-2 mt-2">
                    <div class="custom-control custom-checkbox">
                      <input class="custom-control-input" type="checkbox" id="inlineCheckboxAcom" data-type="acomodacao"
                        @click="toggle" />
                      <label class="custom-control-label" for="inlineCheckboxAcom">
                        Acomodação: {{ textAcom }}
                      </label>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-2 mt-2">
                    <div class="custom-control custom-checkbox">
                      <input class="custom-control-input" type="checkbox" id="inlineCheckboxCop"
                        data-type="coparticipacao" @click="toggle" />
                      <label class="custom-control-label" for="inlineCheckboxCop">
                        Coparticipação: {{ textCop }}
                      </label>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-2 mt-2">
                    <div class="custom-control custom-checkbox">
                      <input class="custom-control-input" type="checkbox" id="inlineCheckboxCom" data-type="compulsorio"
                        @click="toggle" />
                      <label class="custom-control-label" for="inlineCheckboxCom">
                        Compulsório: {{ textCom }}
                      </label>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-2 mt-2">
                    <div class="custom-control custom-checkbox">
                      <input class="custom-control-input" type="checkbox" id="inlineCheckboxMei" data-type="mei"
                        @click="toggle" />
                      <label class="custom-control-label" for="inlineCheckboxMei">
                        MEI: {{ textMei }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mt-2">
                    <template v-if="this.cenarios.length > 0">
                      <button type="button" class="btn btn-warning float-right" @click="confirmar()">
                        Redefinir
                      </button>
                    </template>
                    <button v-else type="button" class="btn btn-warning float-right" @click="confirmar()">
                      Confirmar
                    </button>
                    <template v-if="this.cenarios.length > 0">
                      <button type="button" class="btn btn-danger float-right mr-4" @click="limpar()">
                        Limpar Tudo
                      </button>
                    </template>
                  </div>
                </div>
              </b-collapse>
            </form>
          </div>
        </div>
      </div>
      <ModalFilter :callback="filtered" />
    </div>
  </div>
</template>

<script>
import Diff from "@/components/Diff";
import { mapActions, mapGetters } from "vuex"
import ModalFilter from "@/components/ModalFilter";

export default {
  data() {
    return {
      filters: [],
      parametros: [],
      cidades: [],
      credenciados: [],
      loadingSession: true,

    }
  },
  mixins: [Diff],
  computed: {
    ...mapGetters('modalFilter', ['getFilters', 'getRows', 'getRowsObj']),
    ...mapGetters("cidade", ["getCidades"]),
    ...mapGetters("credenciado", ["getCredenciados"]),
    ...mapGetters("cenario", {
      cenarios: "getCenarios"
    }),
    ...mapGetters("share", {
      filtros: "getFiltros"
    }),
    titulo() {
      return 'SIMP Moderno <a href="https://suporte.agencialink.com.br/simp-simuladores-online/como-utilizar-simp-moderno/" \
        target="_blank" \
        class="suporte">\
          <svg aria-hidden="true" \
            focusable="false" \
            data-prefix="fas" \
            data-icon="graduation-cap" \
            role="img" xmlns="http://www.w3.org/2000/svg" \
            viewBox="0 0 640 512" \
            class="svg-inline--fa fa-graduation-cap fa-w-20">\
            <path fill="currentColor" \
              d="M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z" \
              class="">\
            </path>\
          </svg>\
        </a>';
    },

    subtitulo() {
      return "Selecione as informações a baixo para filtrar"
    },
    textRegrasAceitacao() {
      return this.filtros.regras_aceitacao == "1" ? "Sim" : "Não";
    },
    textCom() {
      return this.filtros.compulsorio > 1
        ? "indiferente"
        : this.filtros.compulsorio == 1
          ? "sim"
          : "não";
    },
    textAcom() {
      return this.filtros.acomodacao > 1
        ? "indiferente"
        : this.filtros.acomodacao == 1
          ? "apartamento"
          : "enfermaria";

    },
    textSomarTaxas() {
      return this.filtros.somar_taxas == null || this.filtros.somar_taxas == 1
        ? "somar"
        : "não somar"
    },
    textCop() {
      return this.filtros.coparticipacao > 1
        ? "indiferente"
        : this.filtros.coparticipacao == 1
          ? "sim"
          : "não";
    },
    textMei() {
      return this.filtros.mei > 1
        ? "indiferente"
        : this.filtros.mei == 1
          ? "sim"
          : "não";
    },

    showRecomendar() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'recomendar') : this.getFilters.length == 0 ? true : false
    },
    showAtuacao() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'atuacao') : this.getFilters.length == 0 ? true : false
    },
    showModalidade() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'modalidade') : this.getFilters.length == 0 ? true : false
    },
    showAcomodacao() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'acomodacao') : this.getFilters.length == 0 ? true : false
    },
    showCoparticipacao() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'coparticipacao') : this.getFilters.length == 0 ? true : false
    },
    showReembolso() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'reembolso') : this.getFilters.length == 0 ? true : false
    },
    showTaxasIOF() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'taxas-iof') : this.getFilters.length == 0 ? true : false
    },
    showInformacoes() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'informacoes') : this.getFilters.length == 0 ? true : false
    },
    showHospitais() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'hospitais') : this.getFilters.length == 0 ? true : false
    },
    showValores() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'valores') : this.getFilters.length == 0 ? true : false
    },
    showResumo() {
      return this.getFilters.length > 0 ? this.checked(this.getFilters, 'resumo') : this.getFilters.length == 0 ? true : false
    }
  },
  watch: {
    filtros: {
      deep: true,
      handler(filtros) {
        //console.log('274')
        //console.log(typeof filtros.naoalertar)
        let oldFiltros = JSON.parse(localStorage.getItem("filtros"));
        localStorage.setItem("filtros", JSON.stringify(filtros))
        this.updateFiltros(filtros)

        if (oldFiltros && oldFiltros.hasOwnProperty('faixas')) delete oldFiltros['faixas']
        if (filtros && filtros.hasOwnProperty('faixas')) delete filtros['faixas']
        
        if(typeof filtros.naoalertar != 'boolean') {
          if (oldFiltros && this.validateDiff(oldFiltros, filtros)) {
            swal("É necessário redefinir ou limpar o comparativo para aplicar o filtro desejado!", {
              icon: "warning",
            });
          }
        } else if(typeof filtros.naoalertar === 'boolean') {
          delete filtros['naoalertar'];
        }
      },
    },

  },
  mounted() {
    this.$nextTick(function () {
      console.log("Filtros::monted()");
      const json = localStorage.getItem("filtros");
      const filtros = JSON.parse(json);

      /*pegando a cidade e uf do usuario*/
      const ujson = JSON.parse(localStorage.getItem(process.env.VUE_APP_CLIENT_ID))
      const user = ujson?.user
      /*pegando a cidade e uf do usuario*/

      this.filtros.tipo_plano = filtros?.tipo_plano || "s";
      this.filtros.contratacao = filtros?.contratacao || "pf";
      this.filtros.coparticipacao = Number.isInteger(filtros?.coparticipacao) ? filtros.coparticipacao : 2;
      this.filtros.compulsorio = Number.isInteger(filtros?.compulsorio) ? filtros.compulsorio : 2;
      this.filtros.regras_aceitacao = this.filtros.regras_aceitacao ? this.filtros.regras_aceitacao : true;
      this.filtros.acomodacao = Number.isInteger(filtros?.acomodacao) ? filtros.acomodacao : 2;
      this.filtros.somar_taxas = filtros != null && filtros.somar_taxas != null && Number.isInteger(filtros?.somar_taxas) ? filtros.somar_taxas : 2; //valor padrão deve ser desligado
      this.filtros.cidade = filtros?.cidade || { id: user.cidade_id, uf: user.uf, cidade: user.cidade };
      this.filtros.credenciado = filtros?.credenciado;
      this.filtros.mei = filtros != null && filtros.mei != null && Number.isInteger(filtros?.mei) ? filtros.mei : 2;
      this.checkedEl(document.getElementById("inlineCheckboxCop"));
      this.checkedEl(document.getElementById("inlineCheckboxCom"));
      this.checkedEl(document.getElementById("inlineCheckboxAcom"));
    });
  },
  methods: {
    ...mapActions('usuario', ['saveSession']),
    ...mapActions("share", ["updateFiltros"]),
    ...mapActions('modalFilter', ['load', 'updateRows']),
    ...mapActions("cidade", ["buscaCidade"]),
    ...mapActions("credenciado", ["buscaCredenciado"]),
    ...mapActions("cenario",
      [
        "updateId",
        "recuperaCenario",
        "removerPlanos",
        "resetRedes",
        "resetRegioes",
        "removerCenarios"
      ]),
    ...mapActions(
      "operadora",
      [
        "resetOperadora",
        "resetOperadoras",
        "resetProduto",
        "resetAdministradora",
        "resetEntidade"
      ]
    ),
    ...mapActions(
      "produto", [
      "resetProdutos",
    ]
    ),
    ...mapActions(
      "plano", [
      "resetPlanos",
      "resetGrupos",
      "resetGrupoTree",
      "resetPlanosPorRede",
      "resetValores"
    ]
    ),

    async confirmar() {
      if (this.cenarios.length > 0) {
        swal({
          title: "Redefinir o simulador ?",
          text: "Após confirmar os grupos e as vidas serão mantidas, mas perderá a configuração dos planos !",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then(async (willDelete) => {
          if (willDelete) {
            this.removerPlanos()
            let id = this.cenarios[0].id
            await this.recuperaCenario({ id: id })
            localStorage.removeItem('cenarios')
            localStorage.removeItem('cotacao_id')
            localStorage.removeItem('cotacao_hash')
            localStorage.removeItem('toggleAllRegiao')
            localStorage.removeItem('toggleAllCidade')
            localStorage.removeItem('toggleRecomendar')
            localStorage.removeItem('showHospitais')
            localStorage.removeItem('showValores')

            await this.resetRedes();
            await this.resetRegioes();
            await this.resetOperadora();
            await this.resetOperadoras();
            await this.resetProduto();
            await this.resetAdministradora();
            await this.resetEntidade();
            await this.resetProdutos();
            await this.resetPlanos();
            await this.resetGrupos();
            await this.resetGrupoTree();
            await this.resetPlanosPorRede();
            await this.resetValores();

            this.$bvModal.show("modal-operadora")
          }
        });
      } else {
        this.removerPlanos()
        await this.updateId({ id: null })
        await this.recuperaCenario({ id: null })
        localStorage.removeItem('cenarios')
        localStorage.removeItem('cotacao_id')
        localStorage.removeItem('cotacao_hash')
        localStorage.removeItem('toggleAllRegiao')
        localStorage.removeItem('toggleAllCidade')
        localStorage.removeItem('toggleRecomendar')
        localStorage.removeItem('showHospitais')
        localStorage.removeItem('showValores')

        await this.resetRedes();
        await this.resetRegioes();
        await this.resetOperadora();
        await this.resetOperadoras();
        await this.resetProduto();
        await this.resetAdministradora();
        await this.resetEntidade();
        await this.resetProdutos();
        await this.resetPlanos();
        await this.resetGrupos();
        await this.resetGrupoTree();
        await this.resetPlanosPorRede();
        await this.resetValores();

        this.$bvModal.show("modal-idade")
      }
    },
    async limpar() {
      swal({
        title: "Limpar todos os dados ?",
        text: "Após confirmar você perderá todas as configurações dos grupos!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await this.removerCenarios();
          localStorage.removeItem('cenarios')
          localStorage.removeItem('cotacao_id')
          localStorage.removeItem('cotacao_hash')
          localStorage.removeItem('toggleAllRegiao')
          localStorage.removeItem('toggleAllCidade')
          localStorage.removeItem('toggleRecomendar')
          localStorage.removeItem('showHospitais')
          localStorage.removeItem('showValores')

          await this.resetRedes();
          await this.resetRegioes();
          await this.resetOperadora();
          await this.resetOperadoras();
          await this.resetProduto();
          await this.resetAdministradora();
          await this.resetEntidade();
          await this.resetProdutos();
          await this.resetPlanos();
          await this.resetGrupos();
          await this.resetGrupoTree();
          await this.resetPlanosPorRede();
          await this.resetValores();

          window.location.reload();
        }
      });
    },

    async modalOpen(tipo) {
      console.log(tipo)
      let exibirCenarios = this.cenarios &&
        this.cenarios.map(
          c => c.operadoras.map(
            o => o.grupos.length
          ).reduce((a, b) => a + b, 0)
        ).reduce((a, b) => a + b, 0) > 0
      if (exibirCenarios) {
        if (this.getLoadAllData()) {
          if (tipo == "personalizar") {
            await this.loadFilters();
            this.$bvModal.show("modal-filter");
            console.log
          } else if (tipo == "envio") {
            this.$bvModal.show("modal-share");
          } else if (tipo == "impressao") {
            this.print();
          }
        }
      } else {
        swal("É necessário adicionar alguns planos para enviar ou imprimir", {
          icon: "warning",
        });
      }
    },
    async getLoadAllData() {
      return (
        !this.loadingSession &&
        !this.loadingValores &&
        !this.loadingRegiao &&
        !this.loadingReembolsos &&
        !this.loadingCarencias &&
        !this.loadingProcedimentos &&
        !this.loadingDocs &&
        !this.loadingInfos &&
        !this.loadingArquivos
      );
    },
    hospitais() {
      return this.cenarios;
    },
    async loadFilters() {
      // console.log('Filtro::loadFilters()');
      await this.load({
        filters: this.getFilters,
        recomendar: [],
        atuacao: [],
        modalidade: [],
        acomodacao: [],
        coparticipacao: [],
        reembolso: [],
        taxas_iof: [],
        informacoes: [],
        hospitais: this.hospitais(),
        valores: [
          "00-18",
          "19-23",
          "24-28",
          "29-33",
          "34-38",
          "39-43",
          "44-48",
          "49-53",
          "54-58",
          "59-+"
        ],
        resumos: []
      });
      this.filters = this.getFilters;
      localStorage.setItem("filters", JSON.stringify(this.getFilters));
      this.filtered();
    },
    async filtered() {
      const id = localStorage.getItem(process.env.VUE_APP_CLIENT_ID);
      const json = JSON.parse(id);
      const user = json?.user;
      let self = this
      this.filters = this.getFilters
      let rows = this.getRowsObj.map(t => {
        if (t.key == 'recomendar') t.show = self.showRecomendar ? 1 : 0
        if (t.key == 'atuacao') t.show = self.showAtuacao ? 1 : 0
        if (t.key == 'modalidade') t.show = self.showModalidade ? 1 : 0
        if (t.key == 'acomodacao') t.show = self.showAcomodacao ? 1 : 0
        if (t.key == 'coparticipacao') t.show = self.showCoparticipacao ? 1 : 0
        if (t.key == 'reembolso') t.show = self.showReembolso ? 1 : 0
        if (t.key == 'taxas-iof') t.show = self.showTaxasIOF ? 1 : 0
        if (t.key == 'informacoes') t.show = self.showInformacoes ? 1 : 0
        if (t.key == 'hospitais') t.show = self.showHospitais ? 1 : 0
        if (t.key == 'valores') t.show = self.showValores ? 1 : 0
        if (t.key == 'resumo') t.show = self.showResumo ? 1 : 0
        return t
      })
      this.updateRows(rows);
    },
    async print() {
      const id = localStorage.getItem(process.env.VUE_APP_CLIENT_ID);
      const json = JSON.parse(id);
      const user = json?.user;

      this.loadingSession = false
      await this.saveSession({
        id: user.token,
        data: {
          user: user,
          cenarios: this.cenarios,
          filters: this.getFilters,
          rows: this.getRows
        }
      })
      this.loadingSession = true
      const cotacao_id = localStorage.getItem('cotacao_id')

      const cenario = this.cenarios[0]
      const operadora = cenario.operadoras[0]
      const filtros = operadora.filtros

      let routeData = this.$router.resolve({
        name: "simulacaoDetalhePrint",
        params: {
          id: cotacao_id ? 'cotacao' : operadora.id
        },
        query: {
          tipo_plano: filtros.tipo_plano,
          contratacao: filtros.contratacao,
          compulsorio: filtros.compulsorio == 2 ? '' : filtros.compulsorio == 1 ? 's' : 'n',
          coparticipacao: filtros.coparticipacao == 2 ? '' : filtros.coparticipacao == 1 ? 's' : 'n',
          acomodacao: filtros.acomodacao == 2 ? '' : filtros.acomodacao == 1 ? 'a' : 'e',
          regras_aceitacao: filtros.regras_aceitacao ? 's' : 'n',
          cidade: filtros.cidade ? filtros.cidade.id : '',
          credenciado: filtros.credenciado ? filtros.credenciado : '',
          entidade: filtros.entidade_profissao?.tipo == 'e' ? filtros.entidade_profissao.value.id : '',
          profissao: filtros.entidade_profissao?.tipo == 'p' ? filtros.entidade_profissao.value.id : '',
          hash: user.token,
          mei: filtros.mei == 2 ? '' : filtros.mei == 1 ? 's' : 'n'
        },
      });
      window.open(routeData.href, "_blank");
    },
    onSearchCidade(search, loading) {
      if (search) {
        loading(true);
        this.searchCidade(loading, search, this);
      }
    },
    searchCidade: _.debounce(async (loading, search, vm) => {
      vm.cidades = [];
      await vm.buscaCidade(search)
      vm.cidades = vm.getCidades;
      loading(false);
    }, 500),
    onSearchCredenciado(search, loading) {
      if (search && this.filtros.cidade) {
        loading(true);
        this.searchCredenciado(loading, search, this);
      }
    },
    searchCredenciado: _.debounce(async (loading, search, vm) => {
      vm.credenciados = [];
      await vm.buscaCredenciado({
        uf: vm.filtros.cidade.uf,
        search: search
      })
      vm.credenciados = vm.getCredenciados;
      loading(false);
    }, 500),
    validateDiff(oldFiltros, filtros) {
      let validate_keys = ["regras_aceitacao", "somar_taxas", "cidade", "credenciado", "acomodacao", "coparticipacao", "compulsorio", "mei"];
      let diff = this.diff(oldFiltros, filtros);
      let diff_key = Object.keys(diff).shift();
      let planos = this.cenarios
        .reduce(function (prev, curr) {
          return [...prev, ...curr.operadoras];
        }, [])
        .reduce(function (prev, curr) {
          return [...prev, ...curr.grupos];
        }, [])
        .reduce(function (prev, curr) {
          return [...prev, ...curr.planos];
        }, [])
      return diff_key ? validate_keys.indexOf(diff_key) != -1 && planos.length > 0 : false;
    },
    toggle(e) {
      this.dataType(e.target);
    },
    checkedEl(el) {
      const type = el.getAttribute("data-type");
      if (this.filtros[type] == 0) {
        el.checked = el.readOnly = false;
      } else if (this.filtros[type] == 1) {
        el.checked = true;
        el.readOnly = false;
        el.indeterminate = false;
      } else if (this.filtros[type] == 2) {
        el.readOnly = el.indeterminate = true;
      }
    },

    dataType(el) {
      const type = el.getAttribute("data-type");
      if (el.readOnly) {
        this.filtros[type] = "0";
        el.checked = el.readOnly = false;
        console.log("filtros:", this.filtros[type]);
        console.log("el checked:", el.checked);
      } else if (!el.checked) {
        this.filtros[type] = "2";
        el.readOnly = el.indeterminate = true;
        console.log("filtros:", this.filtros[type]);
        console.log("el inderteminate:", el.indeterminate);
      } else {
        this.filtros[type] = "1";
        console.log("filtros:", this.filtros[type]);
        console.log("el:", el.checked);
      }
    },
    checked(filters, type) {
      let ops = [...filters]
      let filter = ops.filter(filter => filter.data.item == type)
      let obj = filter.length > 0 ? filter.shift(1) : {}
      return obj.hasOwnProperty('state') ? obj.state.indeterminate || obj.state.checked : false
    },
    toggleTaxas(e) {
      this.filtros.somar_taxas = (e.target.checked) ? 1 : 2;
    }
  },
  components: {
    ModalFilter
  }
}
</script>

<style scoped>
.card {
  z-index: 4;
}

.credenciado_detalhes {
  display: block;
  color: #666;
}
</style>
